import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { contactForm } from "./contact-form";
import { recaptchaObject } from "./recaptcha";
require('parsley');

export class miceContactForm {
	private formEl:any = $('#mice-contact--form');
	private contactBase:any = new contactForm();

	/**
	 * initialize all form inputs with focus and filled effects
	 * @return {any} [description]
	 */
	initTextInputs():any {
		let _self = this;
		let inputElArr:any = _self.formEl.find('input[type="text"], input[type="email"], input[type="url"]');

		_self.contactBase.initFormTextInputs(inputElArr);
	}

	/**
	 * [initSelectizeInputs description]
	 * @return {any} [description]
	 */
	initSelectizeInputs(): any {
		let _self = this;
		let inputSelectArr:any = $.makeArray(_self.formEl.find('select'));
		_self.contactBase.initSelectizeInputs(inputSelectArr);
	}

	/**
	 * [initDatepickerInputs description]
	 * @return {any} [description]
	 */
	initDatepickerInputs(): any {
		let _self = this;
		let inputDateArrFrom   = $('#contact-mice--flightdatefrom');
		let inputDateArrTo   = $('#contact-mice--flightdateto');
		let minDate:any = new Date();
		let maxDate:any = new Date((new Date().getFullYear() + 5).toString());
		_self.contactBase.initDatepickerInputs(inputDateArrFrom, minDate, maxDate);
		_self.contactBase.initDatepickerInputs(inputDateArrTo, minDate, maxDate);

		let inputPasteventdate = $('#contact-mice--pasteventdate');
		let pastEventMinDate = new Date((new Date().getFullYear() - 10).toString());
		let pastEventMaxDate = new Date((new Date()).toString());

		_self.contactBase.initDatepickerInputs(inputPasteventdate, pastEventMinDate, pastEventMaxDate);
	}

	validateForm(): any {
		let _self = this;

		_self.contactBase.validateForm(_self.formEl, function(validation: any) {
			// all your custom validation here
		},
		function(validation:any, formData:any) {
			var url = $('#mice-contact--form').attr("action");
      // success fuctions here
	    $.get(url, _self.formEl.serialize())
				.done((data:any) => {
      		_self.formEl.find('.form-content--wrapper').hide();
      		_self.formEl.find('.form-submission--success').show();
				})
				.fail((error:any) => {
      		_self.formEl.find('.form-content--wrapper').show();
      		_self.formEl.find('.form-submission--success').hide();
				});
		});
	}

	getTotalDelegators(): any{
		$(document).on('change', '.mice-speakers', function() {
			let $miceTotalSpeakers: any = $('#mice-speakers--total');
		    var $miceSpeakersTotal = 0;
		    $('.mice-speakers').each(function(){
		        $miceSpeakersTotal += +$(this).val();
		    });
		    $miceTotalSpeakers.val($miceSpeakersTotal);
		});

		$(document).on('change', '.mice-delegates', function() {
			let $miceTotalDelegates: any = $('#mice-delegates--total');
		    var $miceDelegatesTotal = 0;
		    $('.mice-delegates').each(function(){
		        $miceDelegatesTotal += +$(this).val();
		    });
		    $miceTotalDelegates.val($miceDelegatesTotal);
		});
	}

	showOthersContainer(): any{
		$('#contact--mice--others').change(function(){
			if(this.checked)
	        	$('.contact-publicity--others').show();
	        else
	        	$('.contact-publicity--others').hide();
	    });

	   	$('#contact--mice--organizerothers').change(function(){
			if(this.checked)
	        	$('.contact-returns--others').show();
	        else
	        	$('.contact-returns--others').hide();
	    });

	    $('input[type="radio"]').click(function() {
	       if($(this).attr('id') == 'contact--mice--businessothers') {
	            $('.other-details').show();
	       }
	       else {
	            $('.other-details').hide();
	       }
	   });
	}

	initRecaptcha():any {
		let _self = this;
		let _body = $('body');
		let recaptchaobj = new recaptchaObject();

		let recaptchaInfo:recaptchaInfo = {
			id: 'mice-contact-form-recaptcha',
			cb: 'recaptchaMiceContactSuccess',
			cbObj:	function (response:any) {
								(document.getElementById('mice-contact-form-recaptcha') as HTMLInputElement).value = 'true';
							},
			displayId: 'contact-mice--grecaptcha',
			formEl: _self.formEl
		};

		recaptchaobj.createRecaptchaField(recaptchaInfo);
	}

}

let scope:Element = document.querySelector('#mice-contact--form');
if (scope){
	try {
	let micecontactform = new miceContactForm();
		micecontactform.initTextInputs();
		micecontactform.initSelectizeInputs();
		micecontactform.initDatepickerInputs();
		micecontactform.validateForm();
		micecontactform.getTotalDelegators();
		micecontactform.showOthersContainer();
		micecontactform.initRecaptcha();
	} catch(e) {console.error(e);}
}
